import { CharacterDetails, CharacterSkinStrings, CharacterSlugStrings, UserColourOptions } from "../types/SharedTypes";

export const userColours: Record<UserColourOptions,string> = {
  red: "#F66B6B",
  yellow: "#F7C46C",
  green: "#87D35C",
  blue: "#82CBE4",
  purple: "#7D71DC",
  pink: "#F191C3"
}

export const characters: Record<CharacterSlugStrings, CharacterDetails> = {
  "char_guy": {
    name: 'guy',
    scale: 0.82,
    uiHeight: 3.8,
    previewHeight: -2.4
  },
  "char2": {
    name: 'red',
    scale: 1.4,
    uiHeight: 3.75,
    previewHeight: -2.2
  },
  "char_girl": {
    name: 'girl',
    scale: 0.82,
    uiHeight: 3.5,
    previewHeight: -2.2
  },
  "char_sunny": {
    name: 'sunny',
    scale: 1.4,
    uiHeight: 3.75,
    previewHeight: -2.2
  },
}

export const characterSkinColours: Record<CharacterSkinStrings, string> = {
  dark: "#271c10",
  medium: "#896a4a",
  light: "#e6d2ca"
}